<template>
  <div>
    <h2>{{ getModelName() }}</h2>
    <template v-if="!mod.custom || (mod.custom && !mod.from_duna_catalog)">
      <image-zoom
        :show-message="false"
        :zoom-amount="2"
        :regular="mod.image ? mod.image : 'https://via.placeholder.com/600'"
        :zoom="mod.image ? mod.image : 'https://via.placeholder.com/600'"
      >
      </image-zoom>
      <p>{{ mod.description }}</p>
    </template>
    <div v-else class="card">
      <div class="card-header" role="button">
        <p class="card-header-title">
          {{ $translate('custom_model') | capitalize }}
        </p>
      </div>
      <div class="card-content">
        <div class="content">
          <template v-if="mod.selectedCatalog === 'from_duna_catalog'">
            <b-field
              :type="{ 'is-danger': errors.has('catalog_spec') }"
              :message="errors.first('catalog_spec')"
              :label="$translate('catalog_spec') | capitalize"
              horizontal
            >
              <b-input v-model="mod.catalog_spec" name="catalog_spec" type="text" />
            </b-field>
            <b-field
              :type="{ 'is-danger': errors.has('catalog_pag') }"
              :message="errors.first('catalog_pag')"
              :label="$translate('catalog_pag') | capitalize"
              horizontal
            >
              <b-input v-model="mod.catalog_pag" name="catalog_pag" type="number" />
            </b-field>
            <b-field
              :type="{ 'is-danger': errors.has('model_spec') }"
              :message="errors.first('model_spec')"
              :label="$translate('model_spec') | capitalize"
              horizontal
            >
              <b-input v-model="mod.model_spec" name="model_spec" type="text" />
            </b-field>
          </template>

          <template v-if="mod.selectedCatalog === 'from_duna_site'">
            <b-field
              :type="{ 'is-danger': errors.has('model_from_duna_site') }"
              :message="errors.first('model_from_duna_site')"
              :label="$translate('model_from_duna_site') | capitalize"
              horizontal
            >
              <b-autocomplete
                v-model="mod.model_from_duna_site"
                :data="filteredDataObj"
                field="name"
                :keep-first="true"
                :open-on-focus="true"
                @input="checkModelFromDunaSite"
              />
            </b-field>
            <b-field
              :type="{ 'is-danger': errors.has('color_from_duna_site') }"
              :message="errors.first('color_from_duna_site')"
              :label="$translate('color_from_duna_site') | capitalize"
              horizontal
            >
              <b-input v-model="mod.color_from_duna_site" :disabled="true" name="color_from_duna_site" />
            </b-field>
          </template>

          <template v-if="mod.selectedCatalog == 'from_samples'">
            <b-field horizontal :label="$translate('code_from_samples') | capitalize">
              <img src="@/assets/images/Barcode.png" style="width: 100%;" />
            </b-field>
            <b-field horizontal style="font-weight: bold;">
              12
              <b-input
                v-model="mod.code_from_samples"
                style="margin-top: -5px"
                name="code_from_samples"
                maxlength="7"
                minlength="7"
              />
            </b-field>
          </template>

          <b-field
            :type="{ 'is-danger': errors.has('color_bool') }"
            :message="errors.first('color_bool')"
            :label="$translate('color_bool') | capitalize"
            horizontal
          >
            <b-switch
              v-model="mod.color_bool"
              :disabled="mod.selectedCatalog == 'from_samples' || mod.selectedCatalog == 'from_duna_site'"
            />
          </b-field>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imageZoom from 'vue-image-zoomer'
export default {
  inject: ['$validator'],
  name: 'ImageModel',
  props: ['mod', 'order'],
  components: {
    imageZoom,
  },
  data() {
    return {
      webCatalog: [],
    }
  },
  computed: {
    filteredDataObj() {
      return this.webCatalog.filter(option => {
        return (
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.mod.model_from_duna_site.toLowerCase()) >= 0
        )
      })
    },
  },
  async mounted() {
    this.$db
      .collection('extras')
      .doc('web_catalog')
      .get()
      .then(doc => {
        this.webCatalog = doc.data().web_catalog
      })
  },
  methods: {
    getModelName() {
      return this.mod.custom ? this.$translate('custom_model') : this.mod.name
      //return ""
    },
    checkModelFromDunaSite() {
      if (this.webCatalog.find(el => el.name == this.mod.model_from_duna_site) != undefined) {
        this.mod.color_from_duna_site = this.webCatalog.find(el => el.name == this.mod.model_from_duna_site).color
      } else {
        this.mod.color_from_duna_site = null
      }
    },
  },
}</script
>>
